import { DetailListStatus } from '../../../LazyComponents';

export const getPeriodoYYYYMM = (path: string): string | null => {
  const listStatus = DetailListStatus.getDetailListStatus(path);
  const periodoDate = listStatus.filters['periodo'];
  return periodoDate ? periodoDate.substring(0, 7) : null;
};

export const buildFechaCarga = (yyyymm: string): Date => {
  const fecha = new Date();
  fecha.setFullYear(parseInt(yyyymm.substring(0, 4)));
  fecha.setMonth(parseInt(yyyymm.substring(5, 7)) - 1);
  return fecha;
};

export const sanitizeFileName = (name: string): string => {
  const dot = name.lastIndexOf('.');
  let base = name;
  let ext = '';

  if (dot !== -1) {
    base = name.substring(0, dot);
    ext = name.substring(dot);
  }

  const clean = base
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .replace(/[^a-zA-Z0-9_\-\(\)\[\]]/g, '-')
    .toLowerCase();

  return clean + ext.toLowerCase();
};

export const calcularDuracion = (ini?: string, fin?: string): string => {
  if (!ini || !fin) return '00:00:00';

  const parse = (f: string) => {
    const [d, t] = f.split(' ');
    const [day, mon, yr] = d.split('/').map(Number);
    const [h, m, s] = t.split(':').map(Number);
    return new Date(yr, mon - 1, day, h, m, s);
  };

  const dur = parse(fin).getTime() - parse(ini).getTime();
  if (dur < 0) return '00:00:00';

  const pad = (n: number) => String(n).padStart(2, '0');

  const s = Math.floor((dur / 1000) % 60);
  const m = Math.floor((dur / 60000) % 60);
  const h = Math.floor((dur / 3600000) % 24);

  return `${pad(h)}:${pad(m)}:${pad(s)}`;
};

export const getStatusCircleClass = (estado): string => {
  switch (estado) {
    case false:
      return 'status-films__circle--red';
    case true:
      return 'status-films__circle--green';
    default:
      return 'status-films__circle--yellow';
  }
};

export const getNext10Years = (): number[] => {
  const currentYear = new Date().getFullYear();
  return Array.from({ length: 10 }, (_, i) => currentYear - i);
};
